"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormNumberItemUncontrolled = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const FormItemInput_1 = require("../FormItemInput");
const handleKeyDownFloat = (e) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault();
const handleKeyDownInteger = (e) => ['e', 'E', '+', '-', ".", ","].includes(e.key) && e.preventDefault();
const getKeyDownHandler = (floatNumber) => {
    if (Boolean(floatNumber)) {
        return handleKeyDownFloat;
    }
    else {
        return handleKeyDownInteger;
    }
};
const FormNumberItemUncontrolled = ({ floatNumber, ...props }) => {
    return ((0, jsx_runtime_1.jsx)(FormItemInput_1.FormItemInput, { ...props, type: "number", onKeyDown: getKeyDownHandler(floatNumber) }));
};
exports.FormNumberItemUncontrolled = FormNumberItemUncontrolled;
